import { flex, stack } from "@styled-system/patterns";

export const formWrapperClass = stack({
	justifyContent: "center",
	height: "full",
	maxWidth: "[500px]",
	gap: "32",
	marginX: "auto",
});

export const invitationTitleWrapperClass = stack({
	alignItems: "center",
	justifyContent: "center",
	textAlign: "center",
	gap: "12",
});

export const textCenterClass = stack({
	alignItems: "center",
	justifyContent: "center",
	textAlign: "center",
	gap: "0",
});

export const textRightClass = stack({
	alignItems: "flex-end",
	textAlign: "right",
	gap: "0",
});

export const inputsWrapperClass = stack({
	gap: "12",
});

export const dividerWrapperClass = flex({
	alignItems: "center",
	gap: "4",
	my: "4",
});

export const dividerLineClass = flex({
	flex: "1",
	height: "[1px]",
	backgroundColor: "shade.20",
});
